import { render, staticRenderFns } from "./QuotaWarning.vue?vue&type=template&id=7b4d1bb6"
import script from "./QuotaWarning.vue?vue&type=script&lang=js"
export * from "./QuotaWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports